module.exports = __webpack_public_path__ + "assets/Create_img.aaf7ddb8.png";